<template>
  <div>
    <div
      class="w-full pb-1 truncate text-grey-darker font-semibold"
      v-if="placeholder.length != 0"
    >
      <label v-text="placeholder" :for="name"></label>
      <span v-if="required" class="text-red">*</span>
    </div>
    <div
      :class="[border]"
      class="border rounded-lg overflow-hidden flex flex-row items-center"
    >
      <select
        v-model="val"
        :id="name"
        :disabled="disabled"
        @focus="focus"
        @blur="blur"
        class="w-full p-3 outline-none text-sm border-none bg-white appearance-none"
      >
        <option value="" disabled hidden>{{ select_placeholder }}</option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <img src="@/assets/icons/papsi_dropdown.svg" class="w-icon h-icon mr-2" />
    </div>
    <span v-if="error_message" class="text-xs text-error">
      {{ error_message }}
    </span>
  </div>
</template>
<script>
import mixin from "@/mixin";
export default {
  name: "v-combobox",
  mixins: [mixin],
  props: {
    name: { type: String, required: true },
    placeholder: { type: String, default: "" },
    select_placeholder: { type: String, default: "Select an option" },
    value: { type: [String, Number], default: "" },
    modelValue: { type: [String, Number], default: "" },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
  data() {
    return { val: "", border: "border-grey", error_message: null };
  },
  mounted() {
    this.val = this.modelValue !== undefined && this.modelValue !== null && this.modelValue !== ""
     ? this.modelValue
      : this.value;
  },
  methods: {
    focus() {
      this.border = "border-primary";
      this.$emit("focus", { name: this.name, value: this.val });
    },
    blur() {
      if (!this.val && this.required) {
        this.border = "border-red-light";
        this.error_message = this.lang("lbl_0000318");
      } else {
        this.border = "border-grey";
        this.error_message = null;
      }
      this.$emit("blur", { name: this.name, value: this.val });
    },
  },
  watch: {
    val(value) {
      this.$emit("input", value);
      this.$emit("change", value);
      this.$emit("update:modelValue", value);
    },
    value(value) {
      this.val = value;
    },
        modelValue(value) {
      this.val = value;
    },
  },
};
</script>
<style scoped>
.papsi-icon-mt {
  margin-top: 7px;
}
.papsi-txt-lh {
  line-height: 40px;
}

</style>
